import React, { Fragment, useState, useEffect } from 'react';
import fetch from 'unfetch';
import { csvParse } from 'd3-dsv';

import { sortByKey } from '~/core/scripts/utils';
import partyConfig from '../party-config';
import PartyBars from '../PartyBars';

const parseRow = row => ({
  name: row.party_name,
  valueRel: +row.result,
  valueRelComp: +row.result_comp,
  color: partyConfig[row.party_name] ? partyConfig[row.party_name].max : partyConfig.default.max
});

export async function loadOverallData() {
  const res = await fetch(`data/landtagswahl_th_detail.csv`);
  const csvString = await res.text();
  const data = csvParse(csvString, parseRow);

  data.sort(sortByKey('valueRel'));

  return data;
}

export default (props) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const loadData = async() => {
      const data = await loadOverallData();
      setData(data);
    }

    loadData();
  }, []);

  if (!data) {
    return null;
  }

  return (
    <Fragment>
      <div className="overallresult__legend">
        <div className="overallresult__legend-item now">2019</div>
        <div className="overallresult__legend-item old">Vergleich 2014</div>
      </div>
      <PartyBars
        items={data}
        scaleToMax
        decimalPlaces={1}
      />
    </Fragment>
  );
};
